module.exports = __webpack_public_path__ + "static/media/RepositControllerAndPSU.c2d374cc.png";